/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Anonymise_What_3Inputs */

const cs_gdpr_anonymise_what_3 = /** @type {(inputs: Gdpr_Anonymise_What_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`uživatel se deaktivuje a nemůže se přihlásit`)
};

const en_gdpr_anonymise_what_3 = /** @type {(inputs: Gdpr_Anonymise_What_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a user is deactivated and can't log in`)
};

/**
* | output |
* | --- |
* | "a user is deactivated and can't log in" |
*
* @param {Gdpr_Anonymise_What_3Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_anonymise_what_3 = /** @type {((inputs?: Gdpr_Anonymise_What_3Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Anonymise_What_3Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_anonymise_what_3(inputs)
	return cs_gdpr_anonymise_what_3(inputs)
});